import React, { ReactElement, useEffect } from 'react';
import {
  Breadcrumbs, getTitle, homeBreadcrumb, setTitle,
} from 'slovlex-idsk-react-components';
import { Loader } from 'idsk-react-components';
import { useLocation } from 'react-router';
import usePrispevokVestnikaDetail from '../../module/PrispevokVestnikaDetail/hook/usePrispevokVestnikaDetail';
import Layout from '../Layout';
import GlobalErrors from '../../module/GlobalErrors';
import PrispevokVestnikaDetail from '../../module/PrispevokVestnikaDetail/PrispevokVestnikaDetail';
import PageHeadingWithBackButton from '../../module/PageHeadingWithBackButton';
import SecuredPage from '../../module/SecuredPage';

const PrispevokVestnikaDetailPage = (): ReactElement => {
  const {
    prispevokVestnikaDetail,
    prispevokVestnikaStatus,
  } = usePrispevokVestnikaDetail();
  const currentLocation = useLocation();

  useEffect(() => {
    if (!prispevokVestnikaStatus.loading) {
      setTitle(getTitle());
    }
  }, [prispevokVestnikaStatus.loading]);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          to: '/rezortne-zbierky',
          heading: 'Rezortné zbierky',
        },
        {
          heading: `${prispevokVestnikaDetail?.cislo || 'Detail príspevku'}`,
          to: currentLocation.pathname,
        }]}
      />
      <div className="prispevok-vestnika-detail-page">
        <GlobalErrors />
        <SecuredPage
          requestStatus={prispevokVestnikaStatus.responseCode}
        >
          <Loader loading={prispevokVestnikaStatus.loading}>
            {prispevokVestnikaDetail && (
              <>
                <PageHeadingWithBackButton
                  heading={prispevokVestnikaDetail.nazov}
                  withBackLink
                />
                <PrispevokVestnikaDetail vestnikDetail={prispevokVestnikaDetail} />
              </>
            )}
          </Loader>
        </SecuredPage>
      </div>
    </Layout>
  );
};

export default PrispevokVestnikaDetailPage;
